import axios from 'axios';
import { createContext, useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { BASE_URL } from '../config';

const MyContext = createContext();

const MyProvider = ({ children }) => {

    const BaseUrl = BASE_URL;

    const [showToast, setShowToast] = useState(false);
    const [toastMsg, setToastMsg] = useState("");
    const [isAuth, setIsAuth] = useState(false);
    const [paymentRes, setPaymentRes] = useState("");
    const [paymentloading, setPaymentLoading] = useState(false);
    const [pagList, setPageList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [services, setServices] = useState([]);
    const [ranningData, setRaningData] = useState([]);
    const [biddingList, setBiddingList] = useState([]);
    const [siteTitle, setSiteTitle] = useState(() => {
        return secureLocalStorage.getItem("site_title") || "ZippyGo";
    });
    const [lightLogo, setLightLogo] = useState(() => {
        return secureLocalStorage.getItem("light_logo") || "";
    });
    const [darkLogo, setDarkLogo] = useState(() => {
        return secureLocalStorage.getItem("dark_logo") || "";
    });

    const FetchRef = useRef(false);
    const HomeRef = useRef(false);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchLocation = async () => {
            if (!navigator.geolocation) {
                handleFetchData("0", "0");
                return;
            }
            navigator.geolocation.getCurrentPosition(
                async ({ coords }) => {
                    const lat = String(coords.latitude);
                    const long = String(coords.longitude);
                    handleFetchData(lat, long);
                },
                (error) => {
                    console.warn("Geolocation permission or GPS failed: ", error);
                    // Fallback to "0", "0" so that the user is not stuck on the loading page
                    handleFetchData("0", "0");
                },
                { timeout: 8000 }
            );
        };
        fetchLocation();
        const IsAuth = secureLocalStorage.getItem("isauth");
        setIsAuth(IsAuth);
        handleGetPageList();
    }, []);

    useEffect(() => {
        document.title = siteTitle;
    }, [siteTitle]);

    const triggerToast = (msg) => {
        setToastMsg(msg);
        setShowToast(true);
    };

    const handleCallApi = async (MethodType, ApiUrl, ApiBody) => {
        let res;
        try {
            if (MethodType === "Post") {
                const Response = await axios.post(`${BaseUrl + ApiUrl}`, ApiBody);
                res = Response;
            }
            if (MethodType === "Get") {
                const Response = await axios.get(`${BaseUrl + ApiUrl}`);
                res = Response;
            }
            // console.log(`${ApiUrl}`, res);
            return res;
        } catch (error) {
            console.error(`${ApiUrl}`, error);
            const errMsg = error?.response?.data?.message || error?.message || "Something went wrong. Please try again.";
            triggerToast(errMsg);
            return { data: {} };
        }

    }

    const handleGetPageList = async () => {
        if (FetchRef.current) return;
        FetchRef.current = true;
        const Response = await handleCallApi("Get", "customer/pages_data");
        if (Response?.data?.pages_list) {
            setPageList(Response.data.pages_list);
        }
    }

    const handleFetchData = async (lat, lon) => {
        if (HomeRef.current) return;
        HomeRef.current = true;
        const uid = secureLocalStorage.getItem("Userid") || "0";
        const Response = await handleCallApi("Post", "customer/home", { uid, lat, lon });
        if (Response?.data) {
            if (Response.data.category_list) {
                setServices(Response.data.category_list);
                secureLocalStorage.setItem("categorylist", JSON.stringify(Response.data.category_list));
            }
            if (Response.data.general) {
                secureLocalStorage.setItem("currency", Response.data.general.site_currency);
                secureLocalStorage.setItem("mapkey", Response.data.general.google_map_key);
                secureLocalStorage.setItem("socket_status_banner", Response.data.general.socket_status_banner);
                secureLocalStorage.setItem("out_offer_exprie_time_cus", Response.data.general.out_offer_exprie_time_cus);
                secureLocalStorage.setItem("ren_offer_exprie_time_cus", Response.data.general.ren_offer_exprie_time_cus);
                secureLocalStorage.setItem("pack_offer_exprie_time_cus", Response.data.general.pack_offer_exprie_time_cus);
                if (Response.data.general.web_one_app_id && Response.data.general.web_one_app_id.trim() !== '') {
                    secureLocalStorage.setItem("one_app_id", Response.data.general.web_one_app_id);
                } else {
                    secureLocalStorage.removeItem("one_app_id");
                }
                if (Response.data.general.title) {
                    setSiteTitle(Response.data.general.title);
                    secureLocalStorage.setItem("site_title", Response.data.general.title);
                }
                if (Response.data.general.light_image) {
                    setLightLogo(Response.data.general.light_image);
                    secureLocalStorage.setItem("light_logo", Response.data.general.light_image);
                }
                if (Response.data.general.dark_image) {
                    setDarkLogo(Response.data.general.dark_image);
                    secureLocalStorage.setItem("dark_logo", Response.data.general.dark_image);
                }
            }
            if (Response.data.runnig_ride && Response.data.runnig_ride.length >= 1) {
                const currentPath = window.location.pathname;
                const ignoredPaths = ["/my-rides", "/profile", "/wallet", "/refer-earn", "/faq", "/chat", "/notification", "/payment-response"];
                const shouldRedirect = !ignoredPaths.some(p => currentPath.startsWith(p));
                if (shouldRedirect && Response.data.runnig_ride[0].status == '0') {
                    const role = Response.data.runnig_ride[0].m_role;
                    if (role == '1') {
                        navigate("/find-ride");
                    } else if (role == '2') {
                        navigate("/outstation");
                    } else if (role == '3') {
                        navigate("/hourly-rental");
                    } else if (role == '4') {
                        navigate("/package");
                    }
                }
                setRaningData(Response.data.runnig_ride[0]);
            }
        }
        setLoading(false);
    }

    const handleFetchRunningRide = async () => {
        const uid = secureLocalStorage.getItem("Userid") || "0";
        if (uid === "0") {
            setRaningData(null);
            return;
        }
        try {
            const Response = await handleCallApi("Post", "customer/home", { uid, lat: "0", lon: "0" });
            if (Response?.data) {
                if (Response.data.runnig_ride && Response.data.runnig_ride.length >= 1) {
                    setRaningData(Response.data.runnig_ride[0]);
                } else {
                    setRaningData(null);
                }
            }
        } catch (error) {
            console.error("Error fetching running ride:", error);
        }
    }

    const value = {
        showToast, setShowToast,
        toastMsg, setToastMsg,
        triggerToast,
        isAuth, setIsAuth,
        paymentRes, setPaymentRes,
        paymentloading, setPaymentLoading,
        pagList, setPageList,
        BaseUrl, handleCallApi,
        loading, services, ranningData,
        handleFetchRunningRide, setRaningData,
        biddingList, setBiddingList,
        siteTitle, setSiteTitle,
        lightLogo, setLightLogo,
        darkLogo, setDarkLogo
    }

    return (
        <MyContext.Provider value={value}>
            {children}
        </MyContext.Provider>
    )
}

export { MyContext, MyProvider };